// extracted by mini-css-extract-plugin
export var iconWrapper = "school-info-section-module--iconWrapper--aYndh";
export var icon = "school-info-section-module--icon--0chSE";
export var iconDescription = "school-info-section-module--iconDescription--wvkXI";
export var whyUsSection = "school-info-section-module--whyUsSection--oj4r+";
export var whyUsContentWrapper = "school-info-section-module--whyUsContentWrapper--QDQBq";